import { useLoading } from "@utils/loading/useLoading";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LOGGED_OUT_DEFAULT_ROUTE, useAuth } from "realmsbase-sdk";

interface AdminGuardProps {
  children: any;
}

export const AdminGuard = ({ children }: AdminGuardProps) => {
  const { account } = useAuth({ redirectIfLoggedOut: true });
  const navigate = useNavigate();
  const loadingManager = useLoading();

  useEffect(() => {
    if (!account || !account.isAdmin) {
      const taskId = loadingManager.addTask({
        type: "spinner",
        text: "Authenticating...",
      });
      return () => {
        loadingManager.endTask(taskId);
      };
    }
  }, [account, loadingManager]);

  useEffect(() => {
    if (account && !account.isAdmin) {
      navigate(LOGGED_OUT_DEFAULT_ROUTE);
    }
  }, [account, navigate]);

  return <>{children}</>;
};
